var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/utility/ActionBar/LogoActionBar.tsx";
import React, { useEffect, useRef } from 'react';
import Animated, { Extrapolation, interpolate, useAnimatedStyle } from 'react-native-reanimated';
import { connect } from 'react-redux';
import { HStack, Text, VStack } from '@adc/parallax-component-library';
import { IconBack } from '@adc/parallax-icons';
import { IconButton } from 'Components/utility';
import { ACTION_BAR_SIZE } from 'Reducers/scrollPage/types';
import i18n from 'Utilities/i18n';
import mediator from 'Utilities/mediator';
import { store } from 'Utilities/store';
import { ActionBarHeader } from './ActionBarHeader';
const mapStateToProps = ({
  scrollPage
}) => {
  return {
    scrollPage
  };
};
const connector = connect(mapStateToProps);
const _worklet_330820755791_init_data = {
  code: "function LogoActionBarTsx1(){const{scrollPage,title,interpolate,Extrapolation}=this.__closure;if(!scrollPage.isActive||!title){return{opacity:1};}const opacity=interpolate(scrollPage.scrollValue,[0,20],[1,0],Extrapolation.CLAMP);return{opacity:opacity};}",
  location: "/opt/atlassian/pipelines/agent/build/src/components/utility/ActionBar/LogoActionBar.tsx",
  sourceMap: "{\"version\":3,\"names\":[\"LogoActionBarTsx1\",\"scrollPage\",\"title\",\"interpolate\",\"Extrapolation\",\"__closure\",\"isActive\",\"opacity\",\"scrollValue\",\"CLAMP\"],\"sources\":[\"/opt/atlassian/pipelines/agent/build/src/components/utility/ActionBar/LogoActionBar.tsx\"],\"mappings\":\"AAgE8C,SAAAA,iBAAMA,CAAA,QAAAC,UAAA,CAAAC,KAAA,CAAAC,WAAA,CAAAC,aAAA,OAAAC,SAAA,CAChD,GAAI,CAACJ,UAAU,CAACK,QAAQ,EAAI,CAACJ,KAAK,CAAE,CAClC,MAAO,CACLK,OAAO,CAAE,CACX,CAAC,CACH,CAEA,KAAM,CAAAA,OAAO,CAAGJ,WAAW,CAACF,UAAU,CAACO,WAAW,CAAE,CAAC,CAAC,CAAE,EAAE,CAAC,CAAE,CAAC,CAAC,CAAE,CAAC,CAAC,CAAEJ,aAAa,CAACK,KAAK,CAAC,CAEzF,MAAO,CACLF,OAAA,CAAAA,OACF,CAAC,CACH\",\"ignoreList\":[]}"
};
const _worklet_4963656362496_init_data = {
  code: "function LogoActionBarTsx2(){const{scrollPage,interpolate,Extrapolation}=this.__closure;if(!scrollPage.isActive){return{opacity:0};}const opacity=interpolate(scrollPage.scrollValue,[0,20],[0,1],Extrapolation.CLAMP);return{opacity:opacity};}",
  location: "/opt/atlassian/pipelines/agent/build/src/components/utility/ActionBar/LogoActionBar.tsx",
  sourceMap: "{\"version\":3,\"names\":[\"LogoActionBarTsx2\",\"scrollPage\",\"interpolate\",\"Extrapolation\",\"__closure\",\"isActive\",\"opacity\",\"scrollValue\",\"CLAMP\"],\"sources\":[\"/opt/atlassian/pipelines/agent/build/src/components/utility/ActionBar/LogoActionBar.tsx\"],\"mappings\":\"AA8E+C,SAAAA,iBAAMA,CAAA,QAAAC,UAAA,CAAAC,WAAA,CAAAC,aAAA,OAAAC,SAAA,CACjD,GAAI,CAACH,UAAU,CAACI,QAAQ,CAAE,CACxB,MAAO,CACLC,OAAO,CAAE,CACX,CAAC,CACH,CAEA,KAAM,CAAAA,OAAO,CAAGJ,WAAW,CAACD,UAAU,CAACM,WAAW,CAAE,CAAC,CAAC,CAAE,EAAE,CAAC,CAAE,CAAC,CAAC,CAAE,CAAC,CAAC,CAAEJ,aAAa,CAACK,KAAK,CAAC,CAEzF,MAAO,CACLF,OAAA,CAAAA,OACF,CAAC,CACH\",\"ignoreList\":[]}"
};
const LogoActionBar = ({
  scrollPage,
  title,
  noActionButton,
  onBack,
  actionButtonTestID,
  titleTestID
}) => {
  const actionBarRef = useRef(null);
  useEffect(() => {
    if (actionBarRef.current) {
      const resizeObserver = new ResizeObserver(() => {
        if (actionBarRef.current) {
          store.dispatch({
            type: ACTION_BAR_SIZE,
            actionBarSize: actionBarRef.current.clientHeight
          });
        }
      });
      resizeObserver.observe(actionBarRef.current);
      return () => resizeObserver.disconnect();
    }
  }, []);
  const logoAnimatedStyles = useAnimatedStyle(function LogoActionBarTsx1Factory({
    _worklet_330820755791_init_data,
    scrollPage,
    title,
    interpolate,
    Extrapolation
  }) {
    const _e = [new global.Error(), -5, -27];
    const LogoActionBarTsx1 = function () {
      if (!scrollPage.isActive || !title) {
        return {
          opacity: 1
        };
      }
      const opacity = interpolate(scrollPage.scrollValue, [0, 20], [1, 0], Extrapolation.CLAMP);
      return {
        opacity
      };
    };
    LogoActionBarTsx1.__closure = {
      scrollPage,
      title,
      interpolate,
      Extrapolation
    };
    LogoActionBarTsx1.__workletHash = 330820755791;
    LogoActionBarTsx1.__pluginVersion = "0.5.2";
    LogoActionBarTsx1.__initData = _worklet_330820755791_init_data;
    LogoActionBarTsx1.__stackDetails = _e;
    return LogoActionBarTsx1;
  }({
    _worklet_330820755791_init_data,
    scrollPage,
    title,
    interpolate,
    Extrapolation
  }), [scrollPage.scrollValue, scrollPage.isActive, title]);
  const titleAnimatedStyles = useAnimatedStyle(function LogoActionBarTsx2Factory({
    _worklet_4963656362496_init_data,
    scrollPage,
    interpolate,
    Extrapolation
  }) {
    const _e = [new global.Error(), -4, -27];
    const LogoActionBarTsx2 = function () {
      if (!scrollPage.isActive) {
        return {
          opacity: 0
        };
      }
      const opacity = interpolate(scrollPage.scrollValue, [0, 20], [0, 1], Extrapolation.CLAMP);
      return {
        opacity
      };
    };
    LogoActionBarTsx2.__closure = {
      scrollPage,
      interpolate,
      Extrapolation
    };
    LogoActionBarTsx2.__workletHash = 4963656362496;
    LogoActionBarTsx2.__pluginVersion = "0.5.2";
    LogoActionBarTsx2.__initData = _worklet_4963656362496_init_data;
    LogoActionBarTsx2.__stackDetails = _e;
    return LogoActionBarTsx2;
  }({
    _worklet_4963656362496_init_data,
    scrollPage,
    interpolate,
    Extrapolation
  }), [scrollPage.scrollValue, scrollPage.isActive]);
  return /*#__PURE__*/React.createElement(VStack, {
    ref: actionBarRef,
    style: {
      top: 0,
      left: 0,
      right: 0,
      position: 'absolute',
      zIndex: 2
    },
    backgroundColor: "$surface.container",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 94,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(ActionBarHeader, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 105,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(HStack, {
    padding: "$4",
    justifyContent: "center",
    alignItems: "center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 106,
      columnNumber: 7
    }
  }, !noActionButton && /*#__PURE__*/React.createElement(IconButton, {
    marginLeft: "$4",
    style: {
      position: 'absolute',
      zIndex: 2,
      left: 0,
      cursor: 'pointer'
    },
    onPress: () => onBack ? onBack() : mediator.publish('router:back'),
    testID: actionButtonTestID,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 108,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(IconBack, {
    testID: `${actionButtonTestID}-icon`,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 114,
      columnNumber: 13
    }
  })), /*#__PURE__*/React.createElement(Animated.View, {
    style: logoAnimatedStyles,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 117,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: i18n.t('Global.microcopy.common.libreLogoLight'),
    alt: "",
    id: "Global.libreLogo",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 118,
      columnNumber: 11
    }
  })), title && /*#__PURE__*/React.createElement(Animated.View, {
    style: [{
      position: 'absolute',
      zIndex: 1
    }, titleAnimatedStyles],
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 125,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Text, {
    testID: titleTestID,
    color: "$text.100",
    fontSize: "$h4.strong",
    fontWeight: "$h4.strong",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 126,
      columnNumber: 13
    }
  }, title))));
};
const ConnectedLogoActionBar = connector(LogoActionBar);
export { ConnectedLogoActionBar as LogoActionBar };